import React from 'react';
import Button from '@material-ui/core/Button';
import styles from './WatchListStyles';

const SearchBarWatchList = ({
  isMobile,
  filteredTickers,
  onChange,
  onSave,
  goButton,
  value,
  favLoading,
}) => {
  return (
    <div style={{ display: 'flex', marginLeft: '5px' }}>
      <input
        name="ticker"
        style={isMobile ? styles.tickerInputMobile : styles.tickerInput}
        disabled={favLoading}
        value={value == null ? '' : value}
        onChange={(e) => onChange(e.target.value.toUpperCase())}
        // onKeyDown={(event) => keyPress(event)}
      />

      <Button
        id="btnGO"
        disabled={favLoading}
        variant="contained"
        style={{
          ...styles.goButton,
          minWidth: '22px',
          maxWidth: '22px',
          marginTop: isMobile ? '3px' : '2px',
          height: '26px',
          backgroundColor: 'darkgrey',
          color: 'black',
          border: '1px solid',
          fontSize: '12px',
        }}
        onClick={() => {
          if (!favLoading) {
            goButton();
          }
        }}
      >
        Go
      </Button>
    </div>
  );
};
export default SearchBarWatchList;



// WEBPACK FOOTER //
// ./src/Pages/WatchList/SearchBar.js